import {Space, Tag, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringAnswerType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import * as styles from './answer-competitors.scss';

type PropsType = {
    competitorsMentioned: AiMonitoringAnswerType['competitorsMentioned'];
};

// Rival brands the same answer named, if any.
export function AnswerCompetitors(props: PropsType): JSX.Element | null {
    const {competitorsMentioned} = props;
    const names = competitorsMentioned.map((competitor) => competitor.name).filter(Boolean);

    if (names.length === 0) {
        return null;
    }

    return (
        <div className={styles.answer_competitors}>
            <Typography.Text type="secondary">
                <Locale stringKey="AI_BRAND_MONITORING__ANSWERS__COMPETITORS" />:
            </Typography.Text>
            <Space size={[4, 4]} wrap>
                {names.map((name) => (
                    <Tag color="purple" key={name}>
                        {name}
                    </Tag>
                ))}
            </Space>
        </div>
    );
}
